export default __webpack_public_path__ + "26c5db36623a5f01a0633a0787e9f798.svg";